<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif; background: #f4f6f9; min-height: 100vh;">
    <div class="max-w-5xl mx-auto px-4 py-6">

      <!-- VOLTAR -->
      <button @click="$router.back()" class="flex items-center gap-2 text-slate-500 hover:text-orange-500 transition-colors mb-6 group">
        <v-icon small color="inherit" class="group-hover:-translate-x-1 transition-transform">mdi-arrow-left</v-icon>
        <span class="text-[10px] font-bold uppercase tracking-widest">Voltar para listagem</span>
      </button>

      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="space-y-6 pb-24">

          <!-- SEÇÃO 1: IDENTIFICAÇÃO E FOTO -->
          <section class="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100">
            <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-account-tie-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">IDENTIFICAÇÃO E FOTO</h2>
            </div>

            <div class="p-6">
              <div class="flex flex-col md:flex-row gap-8 items-center md:items-start">
                <!-- FOTO -->
                <div class="flex flex-col items-center gap-2 shrink-0">
                  <div
                    class="w-32 h-32 rounded-lg border-2 border-slate-100 bg-slate-50 overflow-hidden cursor-pointer hover:border-orange-400 transition-colors flex items-center justify-center"
                    @click="$refs.fileInput.click()"
                  >
                    <img
                      v-if="data.attendant_photo"
                      :src="$store.state.urlImages + data.attendant_photo"
                      class="w-full h-full object-cover"
                    />
                    <v-icon v-else color="#cbd5e0" size="40">mdi-account</v-icon>
                  </div>
                  <input type="file" accept="image/jpeg, image/png" @change="uploadImage" ref="fileInput" style="display:none" />
                  <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer hover:text-orange-500 transition-colors" @click="$refs.fileInput.click()">ALTERAR FOTO</span>
                </div>

                <!-- CAMPOS BÁSICOS -->
                <div class="flex-1 w-full">
                  <v-row dense>
                    <v-col cols="12">
                      <label class="field-label">NOME COMPLETO</label>
                      <v-text-field v-model="data.attendant_name" placeholder="DIGITE O NOME COMPLETO" outlined dense hide-details class="field-input font-bold uppercase" />
                    </v-col>
                    
                    <v-col cols="12">
                      <label class="field-label">FORNECEDOR VINCULADO (POSTO)</label>
                      <v-autocomplete
                        v-model="data.provider_id"
                        :items="providers"
                        item-value="provider_id"
                        item-text="provider_name"
                        placeholder="SELECIONE O FORNECEDOR"
                        outlined dense hide-details
                        class="field-input uppercase"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <label class="field-label">CPF</label>
                      <v-text-field v-model="data.attendant_cpf" v-mask-cpf placeholder="000.000.000-00" outlined dense hide-details class="field-input font-bold" :error="!validCpf(data.attendant_cpf) && data.attendant_cpf" />
                    </v-col>

                    <v-col cols="12" md="6">
                      <label class="field-label">DATA DE NASCIMENTO</label>
                      <v-text-field v-model="data.attendant_birth" v-mask-date.br placeholder="DD/MM/AAAA" outlined dense hide-details class="field-input" />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </section>

          <!-- SEÇÃO 2: DADOS PESSOAIS E CONTATO -->
          <section class="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100">
            <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-card-account-details-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DADOS PESSOAIS E CONTATO</h2>
            </div>

            <div class="p-6">
              <v-row dense>
                <v-col cols="12" md="4">
                  <label class="field-label">SEXO</label>
                  <v-select v-model="data.attendant_genre" :items="['Masculino','Feminino','Outros']" placeholder="SELECIONE" outlined dense hide-details class="field-input" />
                </v-col>
                <v-col cols="12" md="4">
                  <label class="field-label">ESTADO CIVIL</label>
                  <v-select v-model="data.attendant_marital_status" :items="['Casado','Solteiro','Viúvo','União Estável']" placeholder="SELECIONE" outlined dense hide-details class="field-input" />
                </v-col>
                <v-col cols="12" md="4">
                  <label class="field-label">ESCOLARIDADE</label>
                  <v-select v-model="data.attendant_education_level" :items="['Fundamental Incompleto','Fundamental Completo','Ensino Médio Incompleto','Ensino Médio Completo','Ensino Superior Incompleto','Ensino Superior Completo','Mestrado','Doutorado']" placeholder="SELECIONE" outlined dense hide-details class="field-input" />
                </v-col>

                <v-col cols="12" md="5" class="mt-4">
                  <label class="field-label">E-MAIL</label>
                  <v-text-field v-model="data.attendant_mail" placeholder="EX@MAIL.COM" outlined dense hide-details class="field-input lowercase" />
                </v-col>
                <v-col cols="12" md="3" class="mt-4">
                  <label class="field-label">CELULAR</label>
                  <v-text-field v-model="data.attendant_cel" v-mask-phone.br placeholder="(00) 00000-0000" outlined dense hide-details class="field-input" />
                </v-col>
                <v-col cols="12" md="4" class="mt-4">
                  <label class="field-label">TELEFONE</label>
                  <v-text-field v-model="data.attendant_tel" v-mask-phone.br placeholder="(00) 0000-0000" outlined dense hide-details class="field-input" />
                </v-col>
              </v-row>
            </div>
          </section>

          <!-- SEÇÃO 3: ENDEREÇO E LOCALIZAÇÃO -->
          <section class="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100">
            <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-map-marker-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ENDEREÇO E LOCALIZAÇÃO</h2>
            </div>

            <div class="p-6">
              <v-row dense>
                <v-col cols="12" md="3">
                  <label class="field-label">CEP</label>
                  <v-text-field v-model="data.attendant_postal_code" v-mask-cep @blur="getCep(data.attendant_postal_code)" placeholder="00.000-000" outlined dense hide-details class="field-input" />
                </v-col>
                <v-col cols="12" md="7">
                  <label class="field-label">LOGRADOURO</label>
                  <v-text-field v-model="data.attendant_street" placeholder="RUA / AVENIDA" outlined dense hide-details class="field-input uppercase" />
                </v-col>
                <v-col cols="12" md="2">
                  <label class="field-label">NÚMERO</label>
                  <v-text-field v-model="data.attendant_number" placeholder="S/N" outlined dense hide-details class="field-input text-center" />
                </v-col>

                <v-col cols="12" md="4" class="mt-4">
                  <label class="field-label">BAIRRO</label>
                  <v-text-field v-model="data.attendant_district" placeholder="BAIRRO" outlined dense hide-details class="field-input uppercase" />
                </v-col>
                <v-col cols="12" md="6" class="mt-4">
                  <label class="field-label">CIDADE</label>
                  <v-text-field v-model="data.attendant_city" placeholder="CIDADE" outlined dense hide-details class="field-input uppercase" />
                </v-col>
                <v-col cols="12" md="2" class="mt-4">
                  <label class="field-label">UF</label>
                  <v-text-field v-model="data.attendant_state" maxlength="2" placeholder="UF" outlined dense hide-details class="field-input text-center uppercase" />
                </v-col>
              </v-row>
            </div>

            <!-- FOOTER AÇÕES -->
            <div class="bg-slate-50 px-6 py-4 border-t border-slate-100 flex justify-end items-center gap-4">
              <button
                type="button"
                @click="$router.back()"
                style="background: none; border: none; cursor: pointer; white-space: nowrap;"
                class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest transition-colors"
              >
                CANCELAR
              </button>
              <button
                type="button"
                @click="validate"
                :disabled="loader"
                style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; width: auto; flex-shrink: 0;"
              >
                <v-icon v-if="loader" small class="animate-spin" color="white">mdi-loading</v-icon>
                <v-icon v-else small color="white">mdi-check</v-icon>
                <span>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
              </button>
            </div>
          </section>
        </div>
      </v-form>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      top
      elevation="24"
      class="custom-snack"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-bold uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    providers: [],
    snack: {
      show: false,
      message: "",
      color: "success"
    },
    data: {
      attendant_id: null,
      attendant_name: "",
      attendant_photo: "",
      attendant_cpf: "",
      attendant_birth: "",
      attendant_genre: "",
      attendant_education_level: "",
      attendant_marital_status: "",
      attendant_mail: "",
      attendant_cel: "",
      attendant_tel: "",
      attendant_postal_code: "",
      attendant_street: "",
      attendant_number: "",
      attendant_complement: "",
      attendant_district: "",
      attendant_city: "",
      attendant_state: "",
      provider_id: null
    }
  }),
  created() {
    this.$http.get("/providers").then(r => (this.providers = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/attendants/${this.id}`).then(r => {
        this.data = r.data[0];
        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    validCpf(cpf) {
      if (!cpf) return false;
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function(j) {
        var soma = 0, r;
        cpf.split(/(?=)/).splice(0, j).forEach(function(e, i) { soma += parseInt(e) * (j + 2 - (i + 1)); });
        r = soma % 11; r = r < 2 ? 0 : 11 - r; if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    },
    validate() {
      if (!this.data.attendant_name || !this.data.provider_id || !this.data.attendant_cpf) {
        this.snack.show = true; this.snack.color = "warning"; this.snack.message = "Atenção: Preencha o Nome, Fornecedor e CPF!"; return;
      }
      this.createOrUpdate();
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/attendants/${this.id}` : "/attendants";
      this.$http[method](url, this.data).then(r => {
        this.snack.show = true; this.snack.message = r.data.result; this.snack.color = "success";
        setTimeout(() => this.$router.push("/attendants-manager"), 1500);
      }).catch(e => {
        this.snack.show = true; this.snack.message = e.message; this.snack.color = "error";
        this.loader = false; this.$store.dispatch("setLoader", false);
      });
    },
    uploadImage(event) {
      if (!event.target.files[0]) return;
      this.$store.dispatch("setLoader", true);
      const fd = new FormData(); fd.append("image", event.target.files[0], event.target.files[0].name);
      this.$http.post("/uploads", fd).then(r => {
        this.data.attendant_photo = r.data.cover; this.$store.dispatch("setLoader", false);
      }).catch(e => {
        alert("Erro ao realizar upload da imagem! " + e.message); this.$store.dispatch("setLoader", false);
      });
    },
    getCep(cep) {
      if (cep && (cep.length == 10 || cep.length == 9)) {
        this.loader = true;
        let c = cep.replace(/\D/g, "");
        this.$http.get("https://viacep.com.br/ws/" + c + "/json/").then(response => {
          if (!response.data.erro) {
            this.data.attendant_street = response.data.logradouro;
            this.data.attendant_district = response.data.bairro;
            this.data.attendant_city = response.data.localidade;
            this.data.attendant_state = response.data.uf;
          }
          this.loader = false;
        }).catch(() => { this.loader = false; });
      }
    }
  }
};
</script>

<style scoped>
.field-label {
  display: block;
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.field-input >>> .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 6px !important;
}

.field-input >>> .v-input__control .v-input__slot fieldset {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}

.field-input >>> .v-input__control .v-input__slot:hover fieldset {
  border-color: #f37021 !important;
}

.field-input >>> input,
.field-input >>> .v-select__selection {
  font-size: 13px !important;
  color: #334155 !important;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 10px !important;
}

@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.animate-spin { animation: spin 1s linear infinite; }
</style>